import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import {
  BreadcrumbService,
  PopUpService,
  License,
  LicensesService,
  UtilsService,
  SubscriptionsService,
  Course,
  ProfileService
} from '../../core';
import { MatTabGroup } from '@angular/material/tabs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lms-license-detail',
  templateUrl: './license-detail.component.html',
  styleUrls: ['./license-detail.component.scss']
})
export class LicenseDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  public license: License;
  public course: Course;
  public tabsManager: any | Subscription = new Subscription();
  public licenseEmailsListId = 'LICENSE_EMAILS_LIST';
  public filters: Object;
  public timezone: any;
  public showMenu: boolean;

  @ViewChild('tabGroup', { static: false }) public tabGroup: MatTabGroup;

  constructor(
    public licensesService: LicensesService,
    public subscriptionsService: SubscriptionsService,
    public route: ActivatedRoute,
    public location: Location,
    public router: Router,
    public translate: TranslateService,
    public popupService: PopUpService,
    public breadcrumb: BreadcrumbService,
    public profileService: ProfileService
  ) {}

  public ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.license = data.license;
      this.course = data.course;
      this.timezone = data.client.timezone;
      this.filters = { entityId: this.license['userId'] };
    });

    this.showMenu = this.profileService.canExecute('licenses.delete');
  }

  public ngAfterViewInit(): void {
    this.tabsManager = UtilsService.createTabsManager(this.route, this.tabGroup);
  }

  public ngOnDestroy(): void {
    this.tabsManager.unsubscribe();
  }

  public goBack(): void {
    this.location.back();
  }

  onUpdateLicense(license: License) {
    this.license = license;
  }

  unregister() {
    this.popupService
      .confirmDelete({
        title: this.translate.instant('licenses.cancel.confirm', {
          email: this.license.userEmail
        }),
        size: 'small',
        text:
          this.license.subscriptionType === 'credits'
            ? this.license.status === 'created'
              ? this.translate.instant('licenses.cancel.creditsReturn')
              : this.translate.instant('licenses.cancel.noCreditsReturn')
            : null,
        confirmButtonText: this.translate.instant('nouns.yes')
      })
      .then(() => this.licensesService.updateStatus(this.license.id, 'cancelled'))
      .then((response) => {
        this.license = response;
      })
      .catch((err) => {
        if (err !== 'cancel') {
          this.popupService.showError({
            title: this.translate.instant('licenses.cancelError', {
              email: this.license.userEmail
            }),
            text: err.serverMessage
          });
        }
      });
  }

  setLicenseCompleted() {
    this.popupService
      .confirm({
        title: this.translate.instant('licenses.complete.title'),
        size: 'small',
        html: this.translate.instant('licenses.complete.text', {
          email: this.license.userEmail
        }),
        confirmButtonText: this.translate.instant('nouns.yes')
      })
      .then(() => this.licensesService.forceLicenseCompletion(this.license.id))
      .then((response) => {
        this.license = response;
      })
      .catch((err) => {
        if (err !== 'cancel') {
          this.popupService.showError({
            title: this.translate.instant('licenses.complete.error', {
              email: this.license.userEmail
            }),
            text: err.serverMessage
          });
        }
      });
  }
}
